import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { ModalActionButtons } from '../../../../semantic-ui/components/modal-window/modal-action-buttons';

const ModalHeader = ({ onAddButtonClick, onDownloadButtonClick, onModalClose, isDownloadLoading }) => {
	return (
		<div className="modal-header">
			<div className="modal-header__actions">
				<div
					className={`modal-header__buttons ${
						!onDownloadButtonClick ? 'modal-header__buttons_no-download' : ''
					}`}
				>
					{onDownloadButtonClick && (
						<div
							className={`modal-header__download-button ${
								isDownloadLoading ? 'modal-header__download-button_loading' : ''
							}`}
							onClick={!isDownloadLoading ? onDownloadButtonClick : null}
						/>
					)}

					{onAddButtonClick && <div className="modal-header__header-button" onClick={onAddButtonClick} />}
				</div>
			</div>
			<div className="modal-header__close-button">
				<ModalActionButtons buttons={[{ type: 'close', onClick: onModalClose, text: 'forgot' }]} />
			</div>
		</div>
	);
};

ModalHeader.propTypes = {
	isDownloadLoading: PropTypes.bool,
	onAddButtonClick: PropTypes.func,
	onModalClose: PropTypes.func.isRequired,
	onDownloadButtonClick: PropTypes.func,
};

export { ModalHeader };
